// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1QF0P","content":"GlobalSearch_content__GQB5U"};